import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const RiFairPage = lazy(() =>
  import('../pages/risk-intelligence/FairQuantificationPage').then((m) => ({ default: m.FairQuantificationPage }))
)
const RiRcsaPage = lazy(() =>
  import('../pages/risk-intelligence/RcsaCampaignsPage').then((m) => ({ default: m.RcsaCampaignsPage }))
)
const RiAgentsPage = lazy(() =>
  import('../pages/risk-intelligence/GrcAgentsPage').then((m) => ({ default: m.GrcAgentsPage }))
)
const RiMarketplacePage = lazy(() =>
  import('../pages/risk-intelligence/MarketplacePage').then((m) => ({ default: m.MarketplacePage }))
)
const RiRoiPage = lazy(() =>
  import('../pages/risk-intelligence/RoiCalculatorPage').then((m) => ({ default: m.RoiCalculatorPage }))
)
const RiEvidencePage = lazy(() =>
  import('../pages/risk-intelligence/EvidenceAutomationPage').then((m) => ({ default: m.EvidenceAutomationPage }))
)
const RiAppetitePage = lazy(() =>
  import('../pages/risk-intelligence/RiskAppetiteAnalyticsPage').then((m) => ({ default: m.RiskAppetiteAnalyticsPage }))
)
const RiPredictivePage = lazy(() =>
  import('../pages/risk-intelligence/PredictiveRiskPage').then((m) => ({ default: m.PredictiveRiskPage }))
)

export const riskIntelligenceRoutes: RouteObject[] = [
  {
    path: 'risk-intelligence',
    children: [
      { index: true, element: <RiFairPage /> },
      { path: 'fair', element: <RiFairPage /> },
      { path: 'rcsa', element: <RiRcsaPage /> },
      { path: 'agents', element: <RiAgentsPage /> },
      { path: 'marketplace', element: <RiMarketplacePage /> },
      { path: 'roi', element: <RiRoiPage /> },
      { path: 'evidence-automation', element: <RiEvidencePage /> },
      { path: 'risk-appetite', element: <RiAppetitePage /> },
      { path: 'predictive', element: <RiPredictivePage /> },
    ],
  },
]
